const TC_NUMBER_PATTERN = /^[A-Z]{3}-TC-[A-Z0-9]{10}-\d{2}$/;

export const normalizeTcNumber = (value?: string) =>
  (value || "").replace(/[\u2013\u2014]/g, "-").replace(/\s+/g, "").trim().toUpperCase();

export const getTcVersionIncrementError = (
  currentValue?: string,
  proposedValue?: string
): string | null => {
  const currentVersion = normalizeTcNumber(currentValue);
  const proposedVersion = normalizeTcNumber(proposedValue);
  if (!currentVersion || !proposedVersion || currentVersion === proposedVersion) return null;
  if (!TC_NUMBER_PATTERN.test(currentVersion) || !TC_NUMBER_PATTERN.test(proposedVersion)) return null;

  const currentSuffix = Number(currentVersion.slice(-2));
  const proposedSuffix = Number(proposedVersion.slice(-2));
  if (currentSuffix >= 99) {
    return "TC Version Number cannot increment beyond 99";
  }
  const expectedSuffix = currentSuffix + 1;
  if (proposedSuffix !== expectedSuffix) {
    return `TC Version Number must increment by exactly 1 (${String(expectedSuffix).padStart(2, "0")})`;
  }
  return null;
};
